import { type FC } from "react";
import { Button, Progress } from "antd";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import "./style.less";

export interface ApplicationProgressProps {
  current: number;
  total: number;
  nextLabel: string;
  onNext?: () => void;
  nextDisabled?: boolean;
  className?: string;
}

const ApplicationProgress: FC<ApplicationProgressProps> = ({
  current,
  total,
  nextLabel,
  onNext,
  nextDisabled = false,
  className,
}) => {
  const { t } = useTranslation();
  const percent = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div
      className={`rd-application-progress ${className ?? ""}`}
      data-testid="application-progress"
    >
      <div className="rd-application-progress__status">
        <Progress
          type="circle"
          percent={percent}
          size={41}
          strokeWidth={20}
          strokeColor="#0071CD"
          trailColor="#DFE2E7"
          strokeLinecap="round"
          format={() => (
            <span className="rd-application-progress__percentage">
              {percent}%
            </span>
          )}
          aria-hidden="true"
        />
        <span className="rd-application-progress__label">
          {formatTranslation(
            t("newRatesAndDosage.applicationProgress.label", {
              current,
              total,
            })
          )}
        </span>
      </div>
      <Button
        className="rd-application-progress__next"
        onClick={onNext}
        disabled={nextDisabled}
      >
        {nextLabel}
      </Button>
    </div>
  );
};

export default ApplicationProgress;
